import { Workbook } from 'exceljs';
import { DateTime as DT } from 'luxon';
import type { StockRow } from '@econtractor/types';

export type ExportStocksLabels = {
    prodName: string;
    category: string;
    article: string;
    vendor: string;
    countEnd: string;
    updated: string;
};

const downloadBlob = (blob: Blob, fileName: string) => {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
};

export const exportStocksToExcel = async (
    stocks: StockRow[],
    warehouseId: number,
    labels: ExportStocksLabels,
): Promise<void> => {
    const workbook = new Workbook();
    const sheet = workbook.addWorksheet('Stocks');

    sheet.columns = [
        { header: labels.prodName, key: 'prodName', width: 40 },
        { header: labels.category, key: 'category', width: 22 },
        { header: labels.article, key: 'article', width: 18 },
        { header: labels.vendor, key: 'vendor', width: 24 },
        { header: labels.countEnd, key: 'countEnd', width: 12 },
        { header: labels.updated, key: 'updated', width: 14 },
    ];

    const headerRow = sheet.getRow(1);
    headerRow.font = { bold: true };

    for (const stock of stocks) {
        sheet.addRow({
            prodName: stock.prodName || '',
            category: stock.categoryName || '',
            article: stock.prodArticle || '',
            vendor: stock.vendorName || '',
            countEnd: Number(stock.stockCount) || 0,
            updated: stock.stockUpdated
                ? DT.fromMillis(stock.stockUpdated).toFormat('dd.MM.yyyy')
                : '',
        });
    }

    const stamp = DT.now().toFormat('yyyyMMdd-HHmm');
    const fileName = `warehouse-stocks-${warehouseId}-${stamp}.xlsx`;
    const buffer = await workbook.xlsx.writeBuffer();
    downloadBlob(
        new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        }),
        fileName,
    );
};
